import BaseApi from '../baseApi';

export default class SupportApi extends BaseApi {
  constructor(obj) {
    obj = obj || {};
    super(obj);
  }

  async getAssertion() {
    return this.api.get('/support/assertion');
  }
}
